"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var useForceUpdate = function useForceUpdate() {
  var _useState = (0, _react.useState)(0),
      setTick = _useState[1];

  var update = (0, _react.useCallback)(function () {
    setTick(function (tick) {
      return tick + 1;
    });
  }, []);
  return update;
};

var _default = useForceUpdate;
exports["default"] = _default;